<template>
  <div class="hzc-discuss">
    <div class="mask" @click="closeIndustrial"></div>
    <div class="content">
      <div id="myChartBig" style="width: 920px;height:460px;cursor:pointer"></div>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'childData',
  ],
  data() {
    return {
      optionBig: {
        title: {
          text: "石油苯中石化挂牌价格（元/吨）",
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          data: ['1月', '2月', '3月', '4月', '5月', '6月'],
        },
        yAxis: {},
        series: [
          {
            name: "价格",
            type: "line",
            data: [5, 20, 36, 10, 10, 20]
          }
        ],
        grid: {
          x: 100,
          y: 60,
          x2: 10,
          y2: 80
        },
      },
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.optionBig.series[0].data = this.childData.dateList;
      this.optionBig.xAxis.data = this.childData.timeList;
      // this.optionBig.series[0].name = this.childData.yearList[0];
      this.drawChart();
    })
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'overflow:hidden')
  },
  beforeDestroy() {
    let myChartBig = this.$echarts.init(document.getElementById("myChartBig"));
    myChartBig.dispose();
    document.querySelector('body').removeAttribute('style')
  },
  methods: {
    /**
     * 关闭
     */
    closeIndustrial(val) {
      this.$emit('closeIndustrialCh', val);
    },
    /**
     * 地图配置加载
     */
    drawChart() {
      let myChartBig = this.$echarts.init(document.getElementById("myChartBig"));
      // 使用刚指定的配置项和数据显示图表。
      myChartBig.setOption(this.optionBig);
    },
  }
}
</script>

<style lang="less" scoped>
.hzc-discuss {
  z-index: 101;
  width: 980px;
  height: 466px;
  background-color: #fff;

  .confirm {
    position: fixed;
    right: 10px;
    top: 10px;
    z-index: 110;
    width: 50px;
    cursor: pointer;
  }

  .mask {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  .content {
    width: 980px;
    height: 480px;
    padding:30px 20px;
    display: inline-block;
    background-size: 100% 100%;
    color: #fff;
    z-index: 101;
    position: relative;
    background: #fff;
    border-radius: 5px;
  }
}
</style>
